import { render, staticRenderFns } from "./MiniRhizome.vue?vue&type=template&id=404da96e&"
import script from "./MiniRhizome.vue?vue&type=script&lang=ts&"
export * from "./MiniRhizome.vue?vue&type=script&lang=ts&"
import style0 from "./MiniRhizome.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports